import React from 'react';
import { Route } from '@americanexpress/one-app-router';

const childRoutes = () => [
  <Route key="/" path="/" />,
  <Route key="/nuitee/search" path="/nuitee/search" />,
  <Route key="/nuitee/details" path="/nuitee/details" />,
  <Route key="/lxp/details" path="/lxp/details" />,
  <Route key="/spotnana/details" path="/spotnana/details" />,
];

export default childRoutes;
